export const HORIZONTAL_PADDING_PX = 24;
export const VERTICAL_PADDING_PX = 24;
export const COLUMN_GAP_PX = 4;
export const ROW_GAP_PX = 4;
export const WALL_STROKE_PX = 1;
export const SECTION_STROKE_PX = 0.1;
export const DEFAULT_SHELF_HEIGHT_MM = 30;
export const PLANNER_SAFE_PADDING_PX = 20;
export const MIN_SCALE = 0.05;
export const BOTTOM_PREVIEW_HEIGHT_PX = 75;
export const PAGE = {
    width: 842,
    height: 595,
    margins: { l: 36, t: 36, r: 12, b: 12 + BOTTOM_PREVIEW_HEIGHT_PX },
} as const;
export const CONTENT_AREA = {
    width: PAGE.width - PAGE.margins.l - PAGE.margins.r,
    height: PAGE.height - PAGE.margins.t - PAGE.margins.b,
} as const;
export const TOP_BOX = { width: CONTENT_AREA.width, height: CONTENT_AREA.height } as const;
export const BOTTOM_BOX = { width: CONTENT_AREA.width, height: 0 } as const;
